const React = require('react');

module.exports = () => {
    return (
        <div>
            <div className="c-shine c-tile__shine c-tile__shine--top">
                <div className="c-shine__rail" />
            </div>
            <div className="c-shine c-shine--rev c-tile__shine c-tile__shine--bottom">
                <div className="c-shine__rail" />
            </div>
        </div>
    );
};
